import { render } from "./TPOdashboardView.vue?vue&type=template&id=bfde2b02"
import script from "./TPOdashboardView.vue?vue&type=script&lang=js"
export * from "./TPOdashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__